
const digest = '49015e751b173fbb03d1236b22239132cb976d24b052fa58af83067ba0afa779';
const classes = {"item":"_item_11dzr_1","label":"_label_11dzr_8","selected":"_selected_11dzr_17","descriptionWrapper":"_descriptionWrapper_11dzr_21"};
const css = `._item_11dzr_1 {
  display: flex;
  flex-direction: column;
  padding: 6px 12px;
  position: relative;
  cursor: pointer;
}
._item_11dzr_1 ._label_11dzr_8 {
  font-size: 14px;
  font-weight: 600;
  flex-grow: 1;
}
._item_11dzr_1:hover {
  cursor: pointer;
  background: #d9e8fe;
}
._item_11dzr_1._selected_11dzr_17 {
  background: #0e7bf9;
  color: #ffffff;
}
._item_11dzr_1 ._descriptionWrapper_11dzr_21 {
  display: flex;
  flex-direction: row;
  gap: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  